import { IAIStrategy } from '../AIStrategy';
import { ITile, PipValue, BoardEnd, IBoardTile } from '../../core/types';
import { DominoRules } from '../../core/DominoRules';
import { pickRandom } from '../../utils/helpers';

/**
 * Medium AI Strategy: Heuristic play.
 * Prefers doubles, then highest pip total.
 */
export class MediumStrategy implements IAIStrategy {
  name = 'medium';

  selectTile(hand: ITile[], leftEnd: PipValue | null, rightEnd: PipValue | null, boardTiles: IBoardTile[]): { tile: ITile; end: BoardEnd } | null {
    const playable = DominoRules.getPlayableTiles(hand, leftEnd, rightEnd);
    if (playable.length === 0) return null;

    // Prefer doubles
    const doubles = playable.filter(t => DominoRules.isDouble(t));
    let bestTile = doubles.length > 0 ? this.getHighestTile(doubles) : this.getHighestTile(playable);

    const possibleEnds = DominoRules.getPlayableEnd(bestTile, leftEnd, rightEnd);
    const end = pickRandom(possibleEnds) || 'left';

    return { tile: bestTile, end };
  }

  private getHighestTile(tiles: ITile[]): ITile {
    return tiles.reduce((prev, current) => {
      return (prev.a + prev.b > current.a + current.b) ? prev : current;
    });
  }
}
